export var ClientPortalProtectedLinksEnum = /*#__PURE__*/ function(ClientPortalProtectedLinksEnum) {
    ClientPortalProtectedLinksEnum["Create"] = "/create";
    ClientPortalProtectedLinksEnum["Dashboard"] = "/dashboard";
    ClientPortalProtectedLinksEnum["Job"] = "/jobs";
    ClientPortalProtectedLinksEnum["Registration"] = "/registration";
    ClientPortalProtectedLinksEnum["User"] = "/user";
    ClientPortalProtectedLinksEnum["Timesheets"] = "/timesheets";
    ClientPortalProtectedLinksEnum["Expenses"] = "/expenses";
    ClientPortalProtectedLinksEnum["Workorders"] = "/workorders";
    ClientPortalProtectedLinksEnum["Payments"] = "/payments";
    ClientPortalProtectedLinksEnum["Candidates"] = "/candidates";
    ClientPortalProtectedLinksEnum["Payroll"] = "/payroll";
    ClientPortalProtectedLinksEnum["MatchCandidates"] = "/match";
    ClientPortalProtectedLinksEnum["Onboarding"] = "/onboarding";
    ClientPortalProtectedLinksEnum["RecruitmentSupport"] = "/recruitment-support";
    ClientPortalProtectedLinksEnum["TalentPools"] = "/talent-lists";
    ClientPortalProtectedLinksEnum["Templates"] = "/templates";
    ClientPortalProtectedLinksEnum["PackageTemplate"] = "/package-template";
    ClientPortalProtectedLinksEnum["RateSupport"] = "/rate-support";
    ClientPortalProtectedLinksEnum["JobExtract"] = "/job-extract";
    ClientPortalProtectedLinksEnum["ContractorRateCalculator"] = "/contractor-rate-calculator";
    ClientPortalProtectedLinksEnum["ContractorManagement"] = "/contractor-management";
    ClientPortalProtectedLinksEnum["Reporting"] = "/reporting";
    ClientPortalProtectedLinksEnum["ConsultantManagement"] = "/consultant-management";
    ClientPortalProtectedLinksEnum["Submissions"] = "/submissions";
    ClientPortalProtectedLinksEnum["TimelockEntry"] = "/timelock-entry";
    ClientPortalProtectedLinksEnum["PTORequests"] = "/pto-requests";
    ClientPortalProtectedLinksEnum["RateCalculator"] = "/contractor-rate-calculator";
    ClientPortalProtectedLinksEnum["ResourceCentre"] = "/resource-library";
    ClientPortalProtectedLinksEnum["Anonymous"] = "/share";
    ClientPortalProtectedLinksEnum["SalesResourceCentre"] = "/resource-centre";
    ClientPortalProtectedLinksEnum["AutoSso"] = "/sso";
    return ClientPortalProtectedLinksEnum;
}({});
export var UnProtectedLinksEnum = /*#__PURE__*/ function(UnProtectedLinksEnum) {
    UnProtectedLinksEnum["Login"] = "/";
    return UnProtectedLinksEnum;
}({});
export var PageNotFound = '/page-not-found';
export var FrictionLessViewNoAccessContent = '/frictionless-view';
export var UserPermissionsRoutes = /*#__PURE__*/ function(UserPermissionsRoutes) {
    UserPermissionsRoutes["isJobEnabled"] = "/jobs";
    UserPermissionsRoutes["isExpenseEnabled"] = "/expenses";
    UserPermissionsRoutes["isPaymentEnabled"] = "/payments";
    UserPermissionsRoutes["isTimesheetEnabled"] = "/timesheets";
    UserPermissionsRoutes["isWorkOrderEnabled"] = "/workorders";
    UserPermissionsRoutes["isOnboardingEnabled"] = "/onboarding";
    UserPermissionsRoutes["isZendeskEnabled"] = "https://helpdesk.procomservices.com/hc/en-us";
    UserPermissionsRoutes["isTimeClockEntryEnabled"] = "/timelock-entry";
    UserPermissionsRoutes["isPtoRequestEnabled"] = "/pto-requests";
    return UserPermissionsRoutes;
}({});
